import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';

/** @category Banking */
export function useBankAccountFields({ countryCode, currencyCode }) {
  const tokenizedApi = useTokenizedApi();
  return useQuery(
    tokenizedApi.banking.linkAccountFieldsQuery(countryCode, currencyCode),
  )?.data?.fields;
}
